<template>
  <div class="ord">
    <div class="container">
      <searchBar
        @search-request="getOrders"
        def_source_id="10"
        def_delivery_status="Shipped"
        def_date_to="from_dt"
        def_date_fm="to_dt"
      />
      <searchResults :key="searchRefresh" v-model="orderlist" />
    </div>
  </div>
</template>

<script>
import { apiService } from "@/common/api.service";
import searchBar from "@/components/SearchBar.vue"; // The @ symbol is a shortcut for src folder
import searchResults from "@/components/SearchResults.vue";

export default {
  name: "orders",
  props: {
    src_id: {
      type: Number,
      required: false,
      default: 11
    },
    from_dt: {
      type: Date,
      required: false
    },
    to_dt: {
      type: Date,
      required: false
    },
    ord_ref: {
      type: String,
      required: false
    },
    delstat: {
      type: String,
      required: false,
      default: "Shipped"
    }
  },
  components: {
    searchBar,
    searchResults
  },
  data() {
    return {
      searchRefresh: 0,
      orderlist: []
    };
  },
  computed: {
    getOrderURL(ref) {
      var ordURL = "<a :href=/order/" + ref + "/</a>";
      return ordURL;
    }
  },
  methods: {
    getOrders(orderParams) {
      this.orderlist = [];
      let endpoint = `/api/orders/`;
      if (orderParams) {
        endpoint += orderParams;
      }
      apiService(endpoint).then(data => {
        this.orderlist.push(...data.results);
      });

      this.searchRefresh++; // Changing the key makes the re-render with the new search results happen
    },
    setToday() {
      this.todaysDate = new Date().toISOString().substr(0, 10);
      this.pastDate = new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 2,
        new Date().getDate()
      )
        .toISOString()
        .substr(0, 10);
    }
  },
  created() {
    this.setToday();
  }
};
</script>
